
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Dropdown, Input } from 'tea-component';
import TimePicker from '@/pages/dashboard/components/TimePicker';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getLocale, useIntl } from 'umi';



const UserFilter = (props: any) => {
  const { onChange, formValue } = props;
  const { getLocalText } = useLocal('component_tracking_day');
  const maximumDays = 90;
  const errorMessage = getLocalText('error', { maximumDays });
  const [filterState, setFilterState] = useState({
    dayOne: formValue?.dayOne,
    dayTwo: formValue?.dayTwo,
    trackingDay: formValue?.trackingDay,
  });

  const [inputValue, setInputValue] = useState(formValue?.trackingDay?.[0]);

  const { formatMessage } = useIntl();
  const trackingDay = formatMessage({id: 'engagement_churn_Tracking_Day'});
  const [dropDownValue, setDropDownValue] = useState('2');
  const [open, setOpen] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setFilterState(
      {
        dayOne: formValue?.dayOne,
        dayTwo: formValue?.dayTwo,
        trackingDay: [inputValue],
      }
    );
    setInputValue(formValue?.trackingDay?.[0]);
  }, [formValue]);
  const handleDayOneChange = (time: any) => {
    const filterVal = {
      ...filterState,
      trackingDay: [inputValue],
      dayOne: time?.format("YYYY-MM-DD")
    };
    setFilterState(filterVal);
    onChange?.(filterVal);
  };

  const handleDayTwoChange = (time: any) => {
    const filterVal = {
      ...filterState,
      trackingDay: [inputValue],
      dayTwo: time?.format("YYYY-MM-DD")
    };
    setFilterState(filterVal);
    onChange?.(filterVal);
  };

  const handleError = (value) => {
    if (isNaN(value) || value > maximumDays || value === '' || value === '0' || value < 1) {
      return true;
    }
    return false;
  };

  const onInputChange = (e: any) => {
    setInputValue(e);
    setIsError(handleError(e));
  };

  const disabledDate = (date)=> {
    // 选择范围在今天之前，且选择跨度不大于七天
    const isAfterToday = date.isAfter(moment(), "day");
    return !isAfterToday;
  };

  return (
    <>
      <TimePicker
        className='register-table-picker'
        onConfirm={handleDayOneChange}
        disabledDate={disabledDate}
        value={filterState.dayOne}
        locale={getLocale()}
      />
      <TimePicker
        className='register-table-picker'
        disabledDate={disabledDate}
        onConfirm={handleDayTwoChange}
        value={filterState.dayTwo}
        locale={getLocale()}
      />
      <Dropdown
        clickClose={false}
        open={open}
        onOpenChange={(val) => {
          setOpen(val);
        }}
        style={{ marginRight: 10 }}
        button={`${trackingDay} ${dropDownValue}`}
        appearance="button"
        className='register-table-select'
        listWidth={340}
      >
        <div className='select-conTip'>
          <Input value={inputValue} className='select-conTip-input' onChange={onInputChange} placeholder={formatMessage({id: 'component_tracking_day_placeholder'})} />
          {
            isError ?
              <div className='select-conTip-text' dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
              : ''
          }
          <div className='select-conTip-flex'>
            <Button type="link" className='select-conTip-btn' disabled={isError} onClick={() => {
              const filterVal = {
                ...filterState,
                trackingDay: [inputValue]
              };
              setDropDownValue(inputValue);
              setOpen(false);
              setFilterState(filterVal);
              onChange?.(filterVal);
            }}>Confirm</Button>
          </div>
        </div>
      </Dropdown>
    </>
  );
};

export default UserFilter;